<div id="cover" *ngIf="projectService.loading()"></div>

<div class="col-md-12 text-end mb-2">
    <button name="add" type="button" class="btn-primary-save" (click)="addProject()">
        <i class="fa fa-plus" title="Add"></i> New Project
    </button>
</div>

<div class="section-page dashboard">
    <div class="container-fluid">
        <ag-grid-angular class="ag-theme-alpine" [rowData]="projectService.getProjectMaster()" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
            (firstDataRendered)="onFirstDataRendered($event)" [pagination]="true" style="height: 100%; width: auto;">
        </ag-grid-angular>
    </div>
</div>

<p-dialog header="Project Details" [(visible)]="commonDataObject.displayDialog" (onHide)="cancel()" [modal]="true"
    [closable]="true" [style]="{width: '600px'}">
    <form [formGroup]="projectForm" autocomplete="off">
        <div class="row">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="col-form-label">Project Name<font color="red">*</font></label>
                            <input id="name" type="text" pInputText formControlName="project_name" />
                        </div>
                        <div class="col-md-12">
                            <label class="col-form-label">Co-ordinator<font color="red">*</font></label>
                            <input id="project_coordinator" type="text" pInputText
                                formControlName="project_coordinator" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="col-form-label">Description<font color="red">*</font></label>
                    <textarea class="form-control" style="height: auto;" [rows]="4" appendTo="body" pInputText
                        name="project_description" formControlName="project_description" appSpacebarDisable></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label class="col-form-label">Co-Coordinator<font color="red">*</font></label>
                    <input id="project_co_coordinator" type="text" pInputText
                        formControlName="project_co_coordinator" />
                </div>
                <div class="col-md-6">
                    <label class="col-form-label">Status</label>
                    <p-toggleSwitch id="is_active" formControlName="is_active"></p-toggleSwitch>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button type="button" class="btn-cancel-secondary" label="Show" (click)="cancel()">
            <i class="fa fa-close"></i> Close
        </button>
        <button type="button" class="btn-primary-save" label="Show" (click)="saveProject()"
            [disabled]="projectForm.invalid">
            <i class="fa fa-save"></i> Save
        </button>
    </ng-template>
</p-dialog>

<p-dialog header="Delete Project" [(visible)]="commonDataObject.deleteDialog" [modal]="true" [closable]="true"
    [style]="{width: '600px'}">
    <div class="row">
        <div class="col-md-12">
            Are you sure you want to delete this project?
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" class="btn-cancel-secondary" label="Show" (click)="commonDataObject.deleteDialog = false">
            No
        </button>
        <button type="button" class="btn-danger-delete" label="Show" (click)="saveProject('Delete')">
            Yes
        </button>
    </ng-template>
</p-dialog>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>